import React from 'react';
import ApplicationForm from '../components/ApplicationForm';
import CourseApplicationForm from '../components/CourseApplicationForm';
import SpecializedPrograms from '../components/SpecializedPrograms';
import CelebratingAchievements from '../components/CelebratingAchievements';
import StudentServices from '../components/StudentServices';
import UniversityEvents from '../components/UniversityEvents';
import FAQ from '../components/FAQ';

const MTechComputerScienceEngineering = () => {
  const [showApplicationModal, setShowApplicationModal] = React.useState(false);

  return (
    <>
      {/* Page Title Banner */}
      <div className="breadcrumbbg page-title aos-init aos-animate" data-aos="fade">
        <div className="container position-relative">
          <div className="row">
            <div className="col-lg-9 mx-auto">
              <h1 className="">M.Tech In Computer Science Engineering</h1>
              <p className="fs-5 text-danger"><strong>Advanced Engineering Program </strong></p>
              <p>Advance your career with our 2-year postgraduate program, designed for B.Tech graduates and working professionals who need flexible learning schedules</p>
            </div>
          </div>
        </div>
      </div>

      {/* Course Overview Section */}
      <section id="overview" className="overview section">
        <div className="container" data-aos="fade-up" data-aos-delay="200">
          <div className="row">
            <div className="col-lg-8">
              <div className="border rounded overflow-hidden">
                <h2 className="fw-bold bg-primary bg-opacity-10 textprimary p-2 px-lg-3">Course Overview</h2>
                <div className="p-2 p-lg-3">
                  <p>The Master of Technology (M.Tech) in Computer Science & Engineering at Mewar University, Chittorgarh, is a forward-thinking postgraduate program designed to cultivate advanced technical expertise, research capabilities, and innovation in computing technologies.</p>
                  
                  <p>This program is ideal for graduates and working professionals seeking to deepen their knowledge in emerging areas such as artificial intelligence, data science, cloud computing, cybersecurity, and software engineering.</p>
                  
                  <p>With a curriculum aligned to industry standards and academic excellence, the program offers a blend of theoretical foundations and practical applications. Students benefit from access to modern computing labs, experienced faculty, and opportunities for research, projects, and industrial collaboration. The flexible structure also makes it adaptable for working professionals looking to enhance their career prospects.</p>
                  
                  <p>The program equips students with specialized knowledge and cutting-edge skills to address the challenges of modern software development, data analytics, and advanced computing solutions.</p>
                </div>
              </div>
              <div className="border rounded overflow-hidden my-3">
                <h4 className="fw-bold bg-primary bg-opacity-10 textprimary p-2 px-lg-3">Course Specialization</h4>
                <div className="row p-2 p-lg-3 d-flex">
                  <div className="col-md-6">
                    <div className="coursesp rounded-1 bg-light d-flex align-items-center">
                      <img className="img-fluid" src="/assets/img/civil-icon.png" alt="mtech civil" />
                      <p className="fs-7 mx-2 mb-0">Data Science</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coursesp rounded-1 bg-light d-flex align-items-center">
                      <img className="img-fluid" src="/assets/img/civil-icon.png" alt="mtech civil" />
                      <p className="fs-7 mx-2 mb-0">Computer Science and Engineering</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <CourseApplicationForm 
                courseName="M.Tech Computer Science Engineering"
                courseValue="M-Tech-Computer-Science-Engineering"
                onApplyClick={() => setShowApplicationModal(true)}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Program Highlights Section */}
      <section id="programht" className="programht section blue-bg">
        <div className="container section-title" data-aos="fade-up" data-aos-delay="200">
          <p><span>Program </span> <span className="description-title">Highlights</span></p>
        </div>
        <div className="container" data-aos="fade-in" data-aos-delay="200">
          <div className="row">
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-cpu"></i>
                  </div>
                  <h5 className="fw-bold w-75">A Program for Specialized Computer Science Engineering</h5>
                </div>
                Mewar University's Computer Science Engineering Program equips students with advanced skills in AI, data science, cybersecurity, and software development for future-ready careers.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-hourglass-top"></i>
                  </div>
                  <h5 className="fw-bold w-75">Flexible for Working Professionals</h5>
                </div>
                Designed with working professionals in mind, the program offers flexible schedules that allow learners to advance their careers without interrupting their jobs.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-bookmark-star-fill"></i>
                  </div>
                  <h5 className="fw-bold w-75">UGC/AICTE Recognized Program</h5>
                </div>
                The UGC and AICTE have recognized Mewar University's M.Tech programs, guaranteeing national recognition and eligibility for competitive tests like GATE and other government exams.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-person-rolodex"></i>
                  </div>
                  <h5 className="fw-bold w-75">Research-Oriented Learning</h5>
                </div>
                MEWAR University offers comprehensive research opportunities that go beyond conventional teaching techniques. Through industry collaborations, live projects, and research initiatives, students gain both theoretical knowledge and practical research experience.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-pc-display-horizontal"></i>
                  </div>
                  <h5 className="fw-bold w-75">Advanced Learning Management System</h5>
                </div>
                Classes are offered in flexible time shifts on weekends, holidays, and weekdays (in the evening, after work hours). The advanced LMS makes recorded lectures and research materials available around-the-clock.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-award"></i>
                  </div>
                  <h5 className="fw-bold w-75">Industry-Relevant Research Projects</h5>
                </div>
                A variety of research components are used in the program, including advanced simulations, industry projects, and cutting-edge research. These components include industry-leading software tools and research methodologies.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-journal-medical"></i>
                  </div>
                  <h5 className="fw-bold w-75">Comprehensive Research Assessment</h5>
                </div>
                Every semester includes research projects, thesis work, and comprehensive assessments. The program emphasizes practical research applications and industry-relevant problem-solving.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-bullseye"></i>
                  </div>
                  <h5 className="fw-bold w-75">Advanced Career Opportunities</h5>
                </div>
                Senior Software Engineer, Technical Architect, Research Scientist, Technology Consultant, and other advanced positions are among the career options open to graduates of the M.Tech Computer Science Engineering program. Additionally, they are eligible for government research positions.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Explore Course Section */}
      <section id="explore-crs" className="explore-crs section bg-light">
        <div className="container section-title" data-aos="fade-up">
          <p><span>Explore </span> <span className="description-title"> Our Course</span></p>
        </div>
        <div className="container" data-aos="fade-up" data-aos-delay="200">
          <div className="row">
            <div className="col-md-12">
              <ul className="nav nav-tabs d-flex aos-init aos-animate" data-aos="fade-up" data-aos-delay="100" role="tablist">
                <li className="nav-item" role="presentation">
                  <a className="nav-link show active" href="#pills-eligibility" data-bs-toggle="tab" data-bs-target="#pills-eligibility" aria-selected="true" role="tab">
                    <h4>Eligibility Criteria</h4>
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" href="#pills-pro-duration" data-bs-toggle="tab" data-bs-target="#pills-pro-duration" aria-selected="false" role="tab" tabIndex="-1">
                    <h4>Program Duration</h4>
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" href="#pills-fee-structure" data-bs-toggle="tab" data-bs-target="#pills-fee-structure" aria-selected="false" role="tab" tabIndex="-1">
                    <h4>Fee Structure</h4>
                  </a>
                </li>
              </ul>

              <div className="tab-content bg-white border rounded-3 p-3 p-lg-4 shadow-sm" id="pills-tabContent">
                <div className="tab-pane fade active show" id="pills-eligibility" role="tabpanel" aria-labelledby="pills-eligibility-tab" tabIndex="0">
                  <h4 className="fw-600 textprimary mb-3 mb-lg-4">
                    Eligibility Criteria
                    <div className="borderbottom-gradient"></div>
                  </h4>
                  <div className="qualification">
                    <h6 className="fw-600 mb-3">Qualification</h6>
                    <ol>
                      <li className="mb-2">This program is for those who have completed a B.E. or B.Tech in Computer Science and Engineering or the relevant field.</li>
                      <li className="mb-2">The candidate must also have at least one year of work experience in a relevant industry.</li>
                      <li className="mb-2">It is also suitable for people who have relevant knowledge and want to gain full knowledge in key areas of industry.</li>
                    </ol>
                  </div>
                  <div className="age-criteria">
                    <h6 className="fw-600 mb-3">Age Criteria</h6>
                    <ol>
                      <li className="mb-2">There is no age restriction for those who want to pursue this course.</li>
                      <li className="mb-2">People who want to advance their career by understanding advanced computer science principles should apply for this course.</li>
                    </ol>
                  </div>
                </div>

                <div className="tab-pane fade" id="pills-pro-duration" role="tabpanel" aria-labelledby="pills-pro-duration-tab" tabIndex="0">
                  <h4 className="fw-600 textprimary mb-3 mb-lg-4">
                    Program Duration
                    <div className="borderbottom-gradient"></div>
                  </h4>
                  <ol>
                    <li className="mb-2">The program lasts a total of 2 years and is divided into 4 semesters.</li>
                    <li className="mb-2">The course includes theoretical lectures and virtual laboratories where research is conducted remotely using simulations.</li>
                  </ol>
                </div>

                <div className="tab-pane fade" id="pills-fee-structure" role="tabpanel" aria-labelledby="pills-fee-structure-tab" tabIndex="0">
                  <h4 className="fw-600 textprimary mb-3 mb-lg-4">
                    Fee Structure
                    <div className="borderbottom-gradient"></div>
                  </h4>
                  <h6 className="bg-warning bg-opacity-25 p-2 rounded shadow-sm mb-3" style={{width: 'max-content'}}>Course Fee (Per Semester) - ₹ 40,000</h6>
                  <h6 className="bg-warning bg-opacity-25 p-2 rounded shadow-sm mb-3" style={{width: 'max-content'}}>Exam Fee (Per Semester) - ₹ 2000</h6>
                  <h6 className="bg-warning bg-opacity-25 p-2 rounded shadow-sm mb-3" style={{width: 'max-content'}}>Registration Fee (One Time) - ₹ 3000</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Specialized Programs Section */}
      <SpecializedPrograms setShowApplicationModal={setShowApplicationModal} />

      {/* Celebrating Our Achievements Section */}
      <CelebratingAchievements />

      {/* Student Services Section */}
      <StudentServices />

      {/* University Events Section */}
      <UniversityEvents />

      {/* FAQ Section */}
      <FAQ />

      <ApplicationForm 
        show={showApplicationModal} 
        onHide={() => setShowApplicationModal(false)} 
      />
    </>
  );
};

export default MTechComputerScienceEngineering;
